import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';
import { ProductButton, ProductEmptyState } from './ui/ProductUI';

export default class AppErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[Linkit application error]', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="linkit-fatal-state">
        <ProductEmptyState
          icon={<AlertTriangle size={24} />}
          title="Linkit could not open this screen"
          description="Your data has not been changed. Reload the screen, or return home if the problem continues."
          primaryAction={(
            <ProductButton icon={<RotateCcw size={16} />} onClick={() => window.location.reload()}>
              Reload screen
            </ProductButton>
          )}
          secondaryAction={(
            <ProductButton variant="secondary" onClick={() => { window.location.href = '/'; }}>
              Return home
            </ProductButton>
          )}
        />
      </main>
    );
  }
}
